<template>

<div>

    <div style="padding-bottom:10px;">
      <div class="tab-content px-4 pt-0 pb-4">
          <search-box @filterChanged="updateFilter" ref="childRefBox"></search-box>
      </div>
    </div>

    <channel-results @filterChanged="updateFilter" @myClearFilter="clearFilter" :filter="filter"></channel-results>

</div>

</template>

<script>
export default {

  data() {
    return {
      filter: {},
    };
  },

  mounted() {

    if(localStorage.getItem('propper_filter')) {
      this.filter = JSON.parse(localStorage.getItem('propper_filter'));
    }

  },

  methods: {

    updateFilter(val) {
        this.filter = val;
     },

    clearFilter(type) {
    this.$refs.childRefBox.homeFilterClear(type);
    },

  }

};
</script>

<style scoped>
.tab-content > .active {
  display: block;
  background: #0c0c0c;
}

div.tab-content {
  display: block;
  background: #0c0c0c;
  border-radius:0.3rem;
}
</style>